import { SuggestedStrollerOption } from 'mk2/apps/blogs/containers/UserStrollersWidget/UserStrollersWidget.interfaces';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { Action } from 'redux';

///////////////////////////////////////////////////////////////////
// Create connection between user and stroller

export interface UserStrollerConnectionCreateAction extends Action {
    readonly strollerId: number;
    readonly username: string;
}

export const USER_STROLLER_CONNECTION_CREATE_TRIGGER = 'USER_STROLLER_CONNECTION_CREATE_TRIGGER';
export interface UserStrollerConnectionCreateTriggerAction extends UserStrollerConnectionCreateAction, Action {
    readonly type: typeof USER_STROLLER_CONNECTION_CREATE_TRIGGER;
}
export const USER_STROLLER_CONNECTION_CREATE_REQUEST = 'USER_STROLLER_CONNECTION_CREATE_REQUEST';
export interface UserStrollerConnectionCreateRequestAction extends UserStrollerConnectionCreateAction, APIRequestAction {
    readonly type: typeof USER_STROLLER_CONNECTION_CREATE_REQUEST;
}
export interface UserStrollerConnectionCreateNormalizedResponse extends NormalizedResponse {
    readonly result: { stroller: number };
}
export const USER_STROLLER_CONNECTION_CREATE_SUCCESS = 'USER_STROLLER_CONNECTION_CREATE_SUCCESS';
export interface UserStrollerConnectionCreateSuccessAction extends UserStrollerConnectionCreateAction, APISuccessAction<UserStrollerConnectionCreateNormalizedResponse> {
    readonly type: typeof USER_STROLLER_CONNECTION_CREATE_SUCCESS;
}
export const USER_STROLLER_CONNECTION_CREATE_FAILURE = 'USER_STROLLER_CONNECTION_CREATE_FAILURE';
export interface UserStrollerConnectionCreateFailureAction extends UserStrollerConnectionCreateAction, APIFailureAction {
    readonly type: typeof USER_STROLLER_CONNECTION_CREATE_FAILURE;
}

export const userStrollersConnectionCreateTrigger =
    (strollerId: number, username: string): UserStrollerConnectionCreateTriggerAction => ({
        type: USER_STROLLER_CONNECTION_CREATE_TRIGGER, strollerId, username,
    });
export const userStrollersConnectionCreateActions = {
    request: (strollerId: number, username: string): UserStrollerConnectionCreateRequestAction => ({
        type: USER_STROLLER_CONNECTION_CREATE_REQUEST, strollerId, username,
    }),
    success: (strollerId: number, username: string, response: UserStrollerConnectionCreateNormalizedResponse): UserStrollerConnectionCreateSuccessAction => ({
        type: USER_STROLLER_CONNECTION_CREATE_SUCCESS, strollerId, username, response,
    }),
    failure: (strollerId: number, username: string, error: any): UserStrollerConnectionCreateFailureAction => ({
        type: USER_STROLLER_CONNECTION_CREATE_FAILURE, strollerId, username, error,
    }),
};

///////////////////////////////////////////////////////////////////
// Remove connection between user and stroller

export interface UserStrollerConnectionRemoveAction extends Action {
    readonly strollerId: number;
    readonly username: string;
}

export const USER_STROLLER_CONNECTION_REMOVE_TRIGGER = 'USER_STROLLER_CONNECTION_REMOVE_TRIGGER';
export interface UserStrollerConnectionRemoveTriggerAction extends UserStrollerConnectionRemoveAction, Action {
    readonly type: typeof USER_STROLLER_CONNECTION_REMOVE_TRIGGER;
}
export const USER_STROLLER_CONNECTION_REMOVE_REQUEST = 'USER_STROLLER_CONNECTION_REMOVE_REQUEST';
export interface UserStrollerConnectionRemoveRequestAction extends UserStrollerConnectionRemoveAction, APIRequestAction {
    readonly type: typeof USER_STROLLER_CONNECTION_REMOVE_REQUEST;
}
export const USER_STROLLER_CONNECTION_REMOVE_SUCCESS = 'USER_STROLLER_CONNECTION_REMOVE_SUCCESS';
export interface UserStrollerConnectionRemoveSuccessAction extends UserStrollerConnectionRemoveAction {
    readonly type: typeof USER_STROLLER_CONNECTION_REMOVE_SUCCESS;
}
export const USER_STROLLER_CONNECTION_REMOVE_FAILURE = 'USER_STROLLER_CONNECTION_REMOVE_FAILURE';
export interface UserStrollerConnectionRemoveFailureAction extends UserStrollerConnectionRemoveAction, APIFailureAction {
    readonly type: typeof USER_STROLLER_CONNECTION_REMOVE_FAILURE;
}

export const userStrollersConnectionRemoveTrigger =
    (strollerId: number, username: string): UserStrollerConnectionRemoveTriggerAction => ({
        type: USER_STROLLER_CONNECTION_REMOVE_TRIGGER, strollerId, username,
    });
export const userStrollersConnectionRemoveActions = {
    request: (strollerId: number, username: string): UserStrollerConnectionRemoveRequestAction => ({
        type: USER_STROLLER_CONNECTION_REMOVE_REQUEST, strollerId, username,
    }),
    success: (strollerId: number, username: string): UserStrollerConnectionRemoveSuccessAction => ({
        type: USER_STROLLER_CONNECTION_REMOVE_SUCCESS, strollerId, username,
    }),
    failure: (strollerId: number, username: string, error: any): UserStrollerConnectionRemoveFailureAction => ({
        type: USER_STROLLER_CONNECTION_REMOVE_FAILURE, strollerId, username, error,
    }),
};

///////////////////////////////////////////////////////////////////
// Reload suggestions

export interface UserStrollerReloadSuggestionsAction extends Action {
    readonly searchTerm: string;
}

export const USER_STROLLER_RELOAD_SUGGESTIONS_TRIGGER = 'USER_STROLLER_RELOAD_SUGGESTIONS_TRIGGER';
export interface UserStrollerReloadSuggestionsTriggerAction extends UserStrollerReloadSuggestionsAction, Action {
    readonly type: typeof USER_STROLLER_RELOAD_SUGGESTIONS_TRIGGER;
}
export const USER_STROLLER_RELOAD_SUGGESTIONS_REQUEST = 'USER_STROLLER_RELOAD_SUGGESTIONS_REQUEST';
export interface UserStrollerReloadSuggestionsRequestAction extends UserStrollerReloadSuggestionsAction, APIRequestAction {
    readonly type: typeof USER_STROLLER_RELOAD_SUGGESTIONS_REQUEST;
}
export interface UserStrollerReloadSuggestionsNormalizedResponse extends NormalizedResponse {
    readonly result: { suggestedStrollerOptions: SuggestedStrollerOption[] };
}
export const USER_STROLLER_RELOAD_SUGGESTIONS_SUCCESS = 'USER_STROLLER_RELOAD_SUGGESTIONS_SUCCESS';
export interface UserStrollerReloadSuggestionsSuccessAction extends UserStrollerReloadSuggestionsAction, APISuccessAction<UserStrollerReloadSuggestionsNormalizedResponse> {
    readonly type: typeof USER_STROLLER_RELOAD_SUGGESTIONS_SUCCESS;
}
export const USER_STROLLER_RELOAD_SUGGESTIONS_FAILURE = 'USER_STROLLER_RELOAD_SUGGESTIONS_FAILURE';
export interface UserStrollerReloadSuggestionsFailureAction extends UserStrollerReloadSuggestionsAction, APIFailureAction {
    readonly type: typeof USER_STROLLER_RELOAD_SUGGESTIONS_FAILURE;
}

export const userStrollersReloadSuggestionsTrigger =
    (searchTerm: string): UserStrollerReloadSuggestionsTriggerAction => ({
        type: USER_STROLLER_RELOAD_SUGGESTIONS_TRIGGER, searchTerm,
    });
export const userStrollersReloadSuggestionsApi = {
    request: (searchTerm: string): UserStrollerReloadSuggestionsRequestAction => ({
        type: USER_STROLLER_RELOAD_SUGGESTIONS_REQUEST, searchTerm,
    }),
    success: (searchTerm: string, response: UserStrollerReloadSuggestionsNormalizedResponse): UserStrollerReloadSuggestionsSuccessAction => ({
        type: USER_STROLLER_RELOAD_SUGGESTIONS_SUCCESS, searchTerm, response,
    }),
    failure: (searchTerm: string, error: any): UserStrollerReloadSuggestionsFailureAction => ({
        type: USER_STROLLER_RELOAD_SUGGESTIONS_FAILURE, searchTerm, error,
    }),
};

